<template>
  <v-card flat class="event-tile">
    <div class="event-tile__content">
      <div class="event-tile__description">
        <v-img
          lazy-src="/img/benefit-no-image.jpg"
          class="event-tile__picture"
          :alt="'Zdjęcie usługi: ' + title"
          :src="imgSrc ? mediaUrl + imgSrc : '/img/benefit-no-image.jpg'"
        />
        <div class="ml-4">
          <div class="event-tile__title">
            <div class="v-card-h2">{{ title }}</div>
          </div>

          <div class="event-tile__details">
            <div class="v-card-h3" style="word-break: break-word;">{{ subtitle ? subtitle : 'Brak opisu' }}</div>
          </div>
        </div>
      </div>

      <slot />
    </div>
  </v-card>
</template>

<script>
import { mediaMixin } from '@/mixins/media';

// @vuese
// Karta
// @group Base
export default {
  mixins: [mediaMixin],

  props: {
    // Wysokość obrazka
    imgHeight: {
      type: Number,
      required: false,
      default: 250
    },
    // Wielkość awatara
    avatarSize: {
      type: Number,
      required: false,
      default: 50
    },
    // Czy akcje są włączone
    actions: {
      type: Boolean,
      default: true
    },
    // Źródło obrazka
    imgSrc: {
      type: [String, Number],
      default: ''
    },
    // Źródło logo
    logoSrc: {
      type: [String, Number],
      default: ''
    },
    // Tytuł
    title: {
      type: String,
      required: true
    },
    // Podtytuł
    subtitle: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.v-card .v-avatar {
  margin-top: -120px;
  border-radius: 0 !important;
  width: 120px !important;
  height: 120px !important;
  margin-bottom: 1rem;
}
.v-card .v-avatar img {
  border-radius: 0 !important;
  width: 120px !important;
  height: 120px !important;
}
.v-card__title {
  padding-bottom: 0;
}
.v-card__text div {
  padding-bottom: 10px;
}
.v-card__actions {
  padding: 16px;
}
.v-list__tile {
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 0 !important;
}
.v-list__tile__action {
  min-width: 30px;
}
.v-list__tile--avatar {
  height: auto;
  padding: 3px 0;
}
</style>
